<template>

  <div
    class="feed-content"
    :class="{'box-loading': loading}">

    <div
      class="photo"
      v-if="!edit && activity.author_user">
      <Avatar
        :src="imgSrc"
        :name="activity.author_user.name"
        size="40px"
        radius="20px"
        resize="100x100x1" />
    </div>

    <div
      class="content"
      v-if="!edit">

      <div
        v-if="permissions.includes('manage_candidates')"
        class="feed-actions dropdown">
        <button
          class="btn btn-sm btn-light"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          <i class="fas fa-chevron-down" />
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            class="dropdown-item"
            @click="editEvent(activity.event)">
              <i class="fas fa-pencil-alt" /> {{ $t('Edit') }}
            </button>
          <button
            class="dropdown-item"
            @click="deleteEvent(activity.event._id)">
              <i class="fas fa-times" /> {{ $t('Remove') }}
            </button>
        </div>
      </div>

      <div>
        {{ activity.event.type }} em <strong>{{ $d(new Date(activity.event.start_at), 'long') }}</strong> - {{ activity.event.duration }} min
      </div>


      <div class="mt-2">
        <div
          v-if="activity.event.assigned_users && activity.event.assigned_users.length >= 1">
          <strong>{{ $t('Participants') }}:</strong>
          <span
            v-for="(item, index) in activity.event.assigned_users"
            :key="index">
            {{ item.name }}<span v-if="index < (activity.event.assigned_users.length - 1)">, </span>
            </span>
        </div>
        <div
          v-if="activity.event.participants && activity.event.participants.length >= 1">
          <strong>{{ $t('Guests') }}:</strong>
          <span
            v-for="(item, index) in activity.event.participants"
            :key="index"
            :title="item.email">
            {{ item.name || item.email }}<span v-if="index < (activity.event.participants.length - 1)">, </span>
            </span>
        </div>
        <div
          v-if="activity.event.location">
          <strong>{{ $t('Location') }}:</strong> {{ activity.event.location }}
          </div>
        <div
          v-if="activity.event.note"
          class="mt-2"
          style="white-space: pre-wrap;">{{ activity.event.note }}</div>
      </div>

      <div class="mt-2">
        <small>
          <span
            v-tooltip="$d(new Date(activity.created_at), 'long')">
            {{ $d(new Date(activity.created_at), 'short') }}
            </span>
          <span>
            por {{ activity.author_user.name }} -
            </span>
          <router-link
            class="link-discreet"
            :to="{path: '/job/' + activity.job._id }">
            {{ activity.job.title }}
            </router-link>
        </small>
      </div>
    </div>

    <div
      class="content"
      v-if="edit">
      <CandidateEventForm
        :initValue="edit"
        :jobId="activity.job._id"
        @updated="updatedEvent"
        @cancel="editCancel" />
    </div>
  </div>

</template>

<script>
import config from '@/config'
import CandidateEventForm from '../Event/CandidateEventForm.vue'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'CandidateEventItem',
  components: {
    CandidateEventForm,
    Avatar
  },
  props: [
    'activity'
  ],
  data () {
    return {
      loading: false,
      edit: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.activity.author_user.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  created () {
  },
  methods: {
    editEvent (data) {
      this.edit = data
    },
    editCancel () {
      this.edit = false
    },
    updatedEvent () {
      this.$store
      .dispatch('getActivities', {
        _id: this.activity._id
      })
      .then(() => {
        this.edit = false
      })
    },
    deleteEvent (id) {
      const deleteAction = () => {
        this.loading = true

        return this.$store
        .dispatch('deleteEvent', id)
        .then((result) => {
          return this.$store.dispatch('deleteActivity', this.activity._id)
        })
        .then((result) => {
          this.loading = false
          this.$emit('deleted', result)
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Feed/CandidateFeedEventItem.vue